import { MenuModifier, MenuSlot, MenuWeight } from './types';

/**
 * Whether a weight is suppressed for its variant.
 *
 * The menu payload omits `isExcludedFromVariant` when it is unset, so absent and explicit `false` are
 * indistinguishable here and both mean "not excluded". That is narrower than the three-valued
 * ExclusionState the reconcile table shows: a stored `false` in a *patch* is somebody's deliberate
 * un-exclude and worth surfacing, but nothing in this payload lets us tell the two apart.
 */
export function isWeightExcluded(weight: MenuWeight): boolean {
  return weight.isExcludedFromVariant === true;
}

/** How many of a modifier's weights are excluded. Feeds the rollup badge on a collapsed modifier. */
export function countExcludedWeights(modifier: MenuModifier): number {
  return modifier.weights?.filter(isWeightExcluded).length ?? 0;
}

/** How many excluded weights a slot holds across all of its modifiers. */
export function countExcludedWeightsInSlot(slot: MenuSlot): number {
  return slot.modifiers?.reduce((total, modifier) => total + countExcludedWeights(modifier), 0) ?? 0;
}
